import type { ReactNode } from 'react';

/** Nota de rodapé das telas com dados mock. */
export function MockNote({ children = 'Dados fictícios de exemplo' }: { children?: ReactNode }) {
  return <p className="ex-note">{children}</p>;
}
